import { CodeName } from '@models/quoteItem';

export const getAddressPropertyLocationCodeName = (locationKey: string): string => {
  switch (locationKey) {
    case 'street1':
      return CodeName.AddressStreet;
    case 'locationName':
      return CodeName.LocationName;
    case 'street2':
      return CodeName.AddressStreet2;
    case 'city':
      return CodeName.AddressCity;
    case 'state':
      return CodeName.AddressState;
    case 'zipCode':
      return CodeName.AddressZip;
    case 'isAddressValid':
      return CodeName.IsAddressApproved;
    default:
      console.warn('Unhandled location key: ', locationKey);
      return '';
  }
};
